import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
  // The SKUs of the variant opened from a row, for the side drawer.
  variantSkus: { loading: false, data: null, error: "" },
};

export const getAppSalesReport = createAsyncThunk(
  "get-app-sales-report",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("inventory/variant-wise-list", {
        params: data,
      });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getVariantSkus = createAsyncThunk(
  "get-variant-skus",
  async (variantId, { dispatch }) => {
    try {
      const response = await axios.get(`inventory/variant/${variantId}/skus`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const appSalesReportSlice = createSlice({
  name: "appSalesReport",
  initialState,
  reducers: {
    clearVariantSkus: (state) => {
      state.variantSkus = { loading: false, data: null, error: "" };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getVariantSkus.pending, (state) => {
        // Dropped straight away, so the previous variant's codes can never
        // show - or be copied - under the next one's name.
        state.variantSkus = { loading: true, data: null, error: "" };
      })
      .addCase(getVariantSkus.fulfilled, (state, action) => {
        const data = action?.payload?.data?.data;
        state.variantSkus = {
          loading: false,
          data: data?.variant ? data : null,
          error: data?.variant
            ? ""
            : action?.payload?.data?.responseMessage ??
              "Could not load the SKUs for this variant.",
        };
      })
      .addCase(getVariantSkus.rejected, (state) => {
        state.variantSkus = {
          loading: false,
          data: null,
          error: "Could not load the SKUs for this variant.",
        };
      });

    builder
      .addCase(getAppSalesReport.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAppSalesReport.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.variantWiseData ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getAppSalesReport.rejected, (state) => {
        state.loading = false;
        state.list = [];
        state.perPage = "";
        state.total = 0;
      });
  },
});

export const { clearVariantSkus } = appSalesReportSlice.actions;
export default appSalesReportSlice.reducer;
